export default __webpack_public_path__ + "static/media/photo--sm--45.cbe91df4.jpg";